import React from 'react';
import { motion } from 'motion/react';
import { Facebook as FBIcon, Users, Megaphone, Share2 } from 'lucide-react';
import SEO from '../../components/SEO';
import { Link } from 'react-router-dom';

const Facebook = () => {
  return (
    <div className="pt-24 pb-24 bg-[#030303] min-h-screen">
      <SEO 
        title="AI Facebook Post Generator - Grow Your Community"
        description="Generate high-performing Facebook posts, group updates, and ad copy with PlataPost's AI Facebook tool. Engage your audience automatically."
      />

      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-20 mb-40">
          <div className="flex-1 space-y-8">
            <div className="inline-flex items-center gap-3 px-4 py-1.5 rounded-full glass-card border border-white/5 text-blue-400 text-[10px] font-black uppercase tracking-widest leading-none">
              <Users className="w-3.5 h-3.5" />
              <span>Community First</span>
            </div>
            <h1 className="text-5xl lg:text-7xl font-black text-white leading-tight tracking-tighter">AI Facebook <br /> <span className="text-blue-500">Post Generator.</span></h1>
            <p className="text-xl text-gray-400 mb-8 leading-relaxed font-medium">
              Build your community with ease. PlataPost creates posts for Facebook Pages and Groups that actually get people talking and sharing.
            </p>
            <Link to="/dashboard" className="inline-flex px-10 py-5 bg-indigo-600 text-white rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-indigo-700 transition-all shadow-2xl shadow-indigo-600/30">
              Grow My Community
            </Link>
          </div>
          <div className="flex-1 w-full glass-card rounded-[4rem] p-12 flex items-center justify-center border border-white/5 relative overflow-hidden group shadow-2xl shadow-blue-500/5">
             <div className="absolute inset-0 bg-blue-500/5 blur-[100px] pointer-events-none" />
             <div className="w-full max-w-sm bg-white/5 rounded-3xl border border-white/10 p-10 shadow-2xl relative z-10 group-hover:scale-105 transition-transform duration-700">
                <div className="flex items-center gap-4 mb-8">
                   <div className="w-14 h-14 bg-blue-600 rounded-2xl flex items-center justify-center text-white shadow-xl shadow-blue-600/20">
                      <FBIcon className="w-8 h-8" />
                   </div>
                   <div className="h-3 w-1/3 bg-white/10 rounded-full" />
                </div>
                <div className="space-y-4">
                   <div className="h-2.5 w-full bg-white/5 rounded-full" />
                   <div className="h-2.5 w-full bg-white/5 rounded-full" />
                   <div className="h-2.5 w-2/3 bg-blue-500/20 rounded-full shadow-[0_0_10px_rgba(59,130,246,0.2)]" />
                </div>
             </div>
          </div>
        </div>

        <section className="mb-40">
          <div className="text-center mb-24 space-y-4">
            <h2 className="text-4xl lg:text-5xl font-black text-white tracking-tighter leading-tight">Engagement First Content</h2>
            <p className="text-gray-400 font-medium max-w-xl mx-auto">Foster deeper connections with AI-crafted community updates.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
             {[
               { icon: Users, title: "Community Focused", desc: "Posts designed to generate comments and spark discussions in groups." },
               { icon: Megaphone, title: "Promotional Power", desc: "Compelling copy for product launches, events, and special offers." },
               { icon: Share2, title: "Shareable Ideas", desc: "Content themes that users are naturally inclined to share with friends." }
             ].map((feature, i) => (
                <div key={i} className="p-12 glass-card rounded-[3rem] border border-white/5 hover:bg-white/5 transition-all group">
                   <div className="w-20 h-20 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center mb-10 text-blue-400 group-hover:scale-110 group-hover:rotate-6 transition-all shadow-xl shadow-blue-600/5">
                      <feature.icon className="w-10 h-10" />
                   </div>
                   <h3 className="text-3xl font-black text-white mb-6 tracking-tight">{feature.title}</h3>
                   <p className="text-gray-400 leading-relaxed font-medium">{feature.desc}</p>
                </div>
             ))}
          </div>
        </section>

        <div className="text-center glass-card rounded-[4rem] p-24 border border-white/5 relative overflow-hidden shadow-2xl shadow-blue-500/10">
           <div className="absolute inset-0 bg-blue-500/10 blur-[150px] pointer-events-none" />
           <h2 className="text-4xl lg:text-6xl font-black text-white mb-10 tracking-tighter">Want more Facebook reach?</h2>
           <Link to="/booking" className="relative z-10 inline-flex px-12 py-6 bg-indigo-600 text-white rounded-2xl font-black text-sm uppercase tracking-[0.2em] hover:bg-indigo-700 transition-all shadow-2xl shadow-indigo-600/30">
              Get Demo
           </Link>
        </div>
      </div>
    </div>
  );
};

export default Facebook;
